import { date, number, object, string } from "yup";

export class CompteurType {
  static EAU = new CompteurType("eau", "Eau froide", "m³");
  static EAU_CHAUDE = new CompteurType("eau_chaude", "Eau chaude", "m³", "eau");
  static GAZ = new CompteurType("gaz", "Gaz", "m³");
  static CHAUFFAGE = new CompteurType("chauffage", "Chauffage", "Kw/h");
  static ELEC = new CompteurType("elec", "Électricité", "Kw/h");
  static ELEC_HC = new CompteurType(
    "elec_hc",
    "Électricité Heures Creuses",
    "Kw/h",
    "elec",
  );
  static ELEC_HP = new CompteurType(
    "elec_hp",
    "Électricité Heures Pleines",
    "Kw/h",
    "elec",
  );
  static ELEC_BS = new CompteurType(
    "elec_bs",
    "Électricité Basse Saison",
    "Kw/h",
    "elec",
  );
  static ELEC_HS = new CompteurType(
    "elec_hs",
    "Électricité Haute Saison",
    "Kw/h",
    "elec",
  );
  static ELEC_HC_BS = new CompteurType(
    "elec_hc_bs",
    "Électricité Heures Creuses Basse Saison",
    "Kw/h",
    "elec",
  );
  static ELEC_HP_BS = new CompteurType(
    "elec_hp_bs",
    "Électricité Heures Pleines Basse Saison",
    "Kw/h",
    "elec",
  );
  static ELEC_HC_HS = new CompteurType(
    "elec_hc_hs",
    "Électricité Heures Creuses Haute Saison",
    "Kw/h",
    "elec",
  );
  static ELEC_HP_HS = new CompteurType(
    "elec_hp_hs",
    "Électricité Heures Pleines Haute Saison",
    "Kw/h",
    "elec",
  );

  readonly name: string;
  readonly description: string;
  readonly unite: string;
  readonly type: string;

  constructor(name: string, description: string, unite: string, type?: string) {
    this.name = name;
    this.description = description;
    this.unite = unite;
    this.type = type ?? name;
  }

  static fromName(name: string | null | undefined): CompteurType | null {
    if (!name) return null;
    const key = name.toUpperCase() as keyof typeof CompteurType;
    const value = CompteurType[key];
    return value instanceof CompteurType ? value : null;
  }
}

export const compteurValidationSchema = object({
  type: string()
    .oneOf(
      Object.values(CompteurType)
        .filter((v): v is CompteurType => v instanceof CompteurType)
        .map((t) => t.name),
      "Le type de compteur est invalide",
    )
    .required("Le type de compteur est obligatoire"),
  numero_compteur: string().optional(),
  date_releve: date().required("La date de relevé doit être une date valide"),
  valeur: number()
    .required("L'index est obligatoire")
    .min(0, "La valeur doit être positive"),
  id_bien: number().optional(),
  id_property_folder: number().optional(),
  id_file: number().optional(),
});

export const COMPTEUR_INITIAL_VALUE = {
  type: "",
  numero_compteur: "",
  date_releve: "",
  valeur: "",
  id_bien: "",
  id_property_folder: "",
  id_file: "",
};
